import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { SETTINGS } from "@/constants/testIds";
import { toast } from "sonner";

export default function Modules() {
  const { tenant, setTenant, reload } = useAuth();
  const [catalog, setCatalog] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/tenant/modules/catalog");
      setCatalog(data);
    })();
  }, []);

  useEffect(() => {
    if (tenant) setSelected(tenant.modules || []);
  }, [tenant]);

  const toggle = (key, on) => {
    setSelected((s) => (on ? [...new Set([...s, key])] : s.filter((k) => k !== key)));
  };

  const save = async () => {
    try {
      const { data } = await api.patch("/tenant/modules", { modules: selected });
      setTenant(data);
      await reload();
      toast.success("Modules updated.");
    } catch {
      toast.error("Could not save modules.");
    }
  };

  return (
    <div className="px-4 md:px-8 py-8 max-w-4xl mx-auto">
      <div className="mb-8">
        <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground mb-2">Studio</div>
        <h1 className="font-display text-4xl">Modules & subscription</h1>
        <p className="text-muted-foreground text-sm mt-1 max-w-xl">
          Activate only the modules you need. Toggle instantly — data across modules stays connected.
        </p>
      </div>

      <div className="rounded-xl border border-border bg-card divide-y divide-border">
        {catalog.map((m) => {
          const on = selected.includes(m.key);
          const disabled = m.always_on || m.coming_soon;
          return (
            <div key={m.key} className="px-5 py-4 flex items-center gap-4">
              <div className="min-w-0 flex-1">
                <div className="font-display text-xl">{m.name}</div>
                <div className="text-xs text-muted-foreground uppercase tracking-[0.18em] mt-0.5">
                  {m.always_on ? "Always on · Core" : m.coming_soon ? "Coming soon" : "Optional module"}
                </div>
              </div>
              <Switch
                data-testid={SETTINGS.moduleToggle(m.key)}
                checked={on || m.always_on}
                disabled={disabled}
                onCheckedChange={(v) => toggle(m.key, v)}
              />
            </div>
          );
        })}
      </div>

      <div className="mt-6">
        <Button onClick={save} className="rounded-full">Save modules</Button>
      </div>
    </div>
  );
}
